import { SVGProps } from 'react'

export const AnalyticsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 15.5L11 11.5L13 13.5L17 9.5M10 22.5L14 22.5C16.8003 22.5 18.2004 22.5 19.27 21.955C20.2108 21.4757 20.9757 20.7108 21.455 19.77C22 18.7004 22 17.3003 22 14.5L22 10.5C22 7.69974 22 6.29961 21.455 5.23005C20.9757 4.28924 20.2108 3.52434 19.27 3.04497C18.2004 2.5 16.8003 2.5 14 2.5L10 2.5C7.19974 2.5 5.79961 2.5 4.73005 3.04497C3.78924 3.52433 3.02433 4.28924 2.54497 5.23005C2 6.29961 2 7.69974 2 10.5L2 14.5C2 17.3003 2 18.7004 2.54496 19.77C3.02433 20.7108 3.78923 21.4757 4.73004 21.955C5.7996 22.5 7.19973 22.5 10 22.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
